<template>
  <b-tr>
    <!-- rccp -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(conservation.rccp)"
    >
      <v-select
        clearable
        dense
        hide-details="true"
        :items="yesNoOptions"
        item-text="display_name"
        item-value="value"
        v-model="rccp"
        :append-icon="
          conservation.rccp?.source !== 'User Input' &&
          conservation.rccp?.value
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('rccp', rccp)"
      />
    </b-td>
    <!-- cscg -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(conservation.cscg)"
    >
      <v-select
        clearable
        dense
        hide-details="true"
        :items="yesNoOptions"
        item-text="display_name"
        item-value="value"
        v-model="cscg"
        :append-icon="
          conservation.cscg?.source !== 'User Input' &&
          conservation.cscg?.value
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('cscg', cscg)"
      />
    </b-td>
    <!-- equip -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(conservation.equip)"
    >
      <v-select
        clearable
        dense
        hide-details="true"
        :items="yesNoOptions"
        item-text="display_name"
        item-value="value"
        v-model="equip"
        :append-icon="
          conservation.equip?.source !== 'User Input' &&
          conservation.equip?.value
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('equip', equip)"
      />
    </b-td>
    <!-- csp -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(conservation.csp)"
    >
      <v-select
        clearable
        dense
        hide-details="true"
        :items="yesNoOptions"
        item-text="display_name"
        item-value="value"
        v-model="csp"
        :append-icon="
          conservation.csp?.source !== 'User Input' &&
          conservation.csp?.value
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('csp', csp)"
      />
    </b-td>
    <!-- pay_for_practice -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(conservation.pay_for_practice)"
    >
      <v-select
        clearable
        dense
        hide-details="true"
        :items="yesNoOptions"
        item-text="display_name"
        item-value="value"
        v-model="payForPractice"
        :append-icon="
          conservation.pay_for_practice?.source !== 'User Input' &&
          conservation.pay_for_practice?.value
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('payForPractice', payForPractice)"
      />
    </b-td>
    <!-- carbon_offset -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(conservation.carbon_offset)"
    >
      <v-select
        clearable
        dense
        hide-details="true"
        :items="yesNoOptions"
        item-text="display_name"
        item-value="value"
        v-model="carbonOffset"
        :append-icon="
          conservation.carbon_offset?.source !== 'User Input' &&
          conservation.carbon_offset?.value
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('carbonOffset', carbonOffset)"
      />
    </b-td>
    <!-- other_scope_3 -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(conservation.other_scope_3)"
    >
      <v-select
        clearable
        dense
        hide-details="true"
        :items="yesNoOptions"
        item-text="display_name"
        item-value="value"
        v-model="otherScope3"
        :append-icon="
          conservation.other_scope_3?.source !== 'User Input' &&
          conservation.other_scope_3?.value
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('otherScope3', otherScope3)"
      />
    </b-td>
    <!-- biodiversity acres -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(conservation.biodiversity_acres)"
    >
      <v-text-field
        clearable
        dense
        v-model="biodiversityAcres"
        hide-details="true"
        :append-icon="
          conservation.biodiversity_acres.source !== 'User Input' &&
          conservation.biodiversity_acres.value !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('biodiversityAcres', biodiversityAcres)"
      >
      </v-text-field>
    </b-td>
    <b-td class="cell-table white">
      <v-btn icon x-small color="black" @click="handleAdd">
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-btn>
      <v-btn icon x-small color="black" @click="handleDelete">
        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>.
    </b-td>
  </b-tr>
</template>
<script>
import { mapMutations, mapGetters } from "vuex"
import { YES_NO_OPTIONS } from "@/constants"
import { Defaults } from "@/store/modules"
import { getClassForCell } from "../utils"
import PracticeChoiceDropdown from "@/components/dropdowns/PracticeChoiceDropdown"

export default {
  name: "RanchConservationRow",
  props: {
    additionView: { type: Boolean, default: false },
    cropId: { type: Number },
    field: { type: String },
    conservation: { type: Object },
    rowIndex: { type: Number },
    year: { type: String },
  },
  components: {
    PracticeChoiceDropdown,
  },
  data() {
    return {
      showDate: false,
      yesNoOptions: YES_NO_OPTIONS,
      getClassForCell,
    }
  },
  computed: {
    ...mapGetters({
      practiceChoices: Defaults.Getters.getPracticeChoices,
    }),
    rccp: {
      get() {
        if (!this.conservation.rccp) {
          return null
        }
        if (typeof this.conservation.rccp.value == "string") {
          return this.yesNoMapper[this.conservation.rccp.value]
        }

        return this.conservation.rccp.value
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "conservation",
          dataSetting: "rccp",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetMutate(updatePayload)
      },
    },
    cscg: {
      get() {
        if (!this.conservation.cscg) {
          return null
        }
        if (typeof this.conservation.cscg.value == "string") {
          return this.yesNoMapper[this.conservation.cscg.value]
        }

        return this.conservation.cscg.value
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "conservation",
          dataSetting: "cscg",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetMutate(updatePayload)
      },
    },
    equip: {
      get() {
        if (!this.conservation.equip) {
          return null
        }
        if (typeof this.conservation.equip.value == "string") {
          return this.yesNoMapper[this.conservation.equip.value]
        }

        return this.conservation.equip.value
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "conservation",
          dataSetting: "equip",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetMutate(updatePayload)
      },
    },
    csp: {
      get() {
        if (!this.conservation.csp) {
          return null
        }
        if (typeof this.conservation.csp.value == "string") {
          return this.yesNoMapper[this.conservation.csp.value]
        }

        return this.conservation.csp.value
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "conservation",
          dataSetting: "csp",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetMutate(updatePayload)
      },
    },
    payForPractice: {
      get() {
        if (!this.conservation.pay_for_practice) {
          return null
        }
        if (typeof this.conservation.pay_for_practice.value == "string") {
          return this.yesNoMapper[this.conservation.pay_for_practice.value]
        }

        return this.conservation.pay_for_practice.value
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "conservation",
          dataSetting: "pay_for_practice",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetMutate(updatePayload)
      },
    },
    carbonOffset: {
      get() {
        if (!this.conservation.carbon_offset) {
          return null
        }
        if (typeof this.conservation.carbon_offset.value == "string") {
          return this.yesNoMapper[this.conservation.carbon_offset.value]
        }

        return this.conservation.carbon_offset.value
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "conservation",
          dataSetting: "carbon_offset",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetMutate(updatePayload)
      },
    },
    otherScope3: {
      get() {
        if (!this.conservation.other_scope_3) {
          return null
        }
        if (typeof this.conservation.other_scope_3.value == "string") {
          return this.yesNoMapper[this.conservation.other_scope_3.value]
        }

        return this.conservation.other_scope_3.value
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "conservation",
          dataSetting: "other_scope_3",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetMutate(updatePayload)
      },
    },
    biodiversityAcres: {
      get() {
        return this.conservation.biodiversity_acres.value
      },
      set(val) {
        if (val === "") {
          val = null
        }
        let validVal = this.handleValidateValue(val, "number")
        if (validVal) {
          const updatePayload = {
            fieldId: this.field,
            year: this.year,
            crop: this.cropId,
            dataCategory: "conservation",
            dataSetting: "biodiversity_acres",
            value: val,
            rowIndex: this.rowIndex,
          }
          this.spreadsheetMutate(updatePayload)
        }
      },
    }
  },
  methods: {
    ...mapMutations({
      addFieldSettingRow: Defaults.Mutations.addFieldSettingRow,
      deleteNewFieldSetting: Defaults.Mutations.deleteNewFieldSetting,
      updateNewFieldSetting: Defaults.Mutations.updateNewFieldSetting,
      spreadsheetMutate: Defaults.Mutations.spreadsheetMutate,
    }),
    handleClickSubmit(setting, val) {
      this[setting] = val
    },
    handleCopy() {
      this.$emit("handle-copy", this.conservation)
    },
    handleAdd() {
      const payloadObj = {
        crop_id: { source: "User Input", value: this.cropId },
        rccp: { source: "User Input", value: null },
        cscg: { source: "User Input", value: null },
        equip: { source: "User Input", value: null },
        csp: { source: "User Input", value: null },
        pay_for_practice: { source: "User Input", value: null },
        carbon_offset: { source: "User Input", value: null },
        other_scope_3: { source: "User Input", value: null },
        biodiversity_acres: { source: "User Input", value: null },
      }
      this.addFieldSettingRow({
        fieldId: this.field,
        cropId: this.cropId,
        dataCategory: "conservation",
        dataObj: payloadObj,
        year: this.year,
      })
    },
    handleDelete() {
      var defaultObj = {}
      for (const [key, value] of Object.entries(this.conservation)) {
        if (key === "crop_id") defaultObj[key] = value
        else defaultObj[key] = { source: "User Input", value: null }
      }

      this.deleteNewFieldSetting({
        fieldId: this.field,
        cropId: this.cropId,
        dataCategory: "conservation",
        defaultObj: defaultObj,
        rowIndex: this.rowIndex,
        year: this.year,
      })
    },
    handleValidateValue(val, type, length = 24) {
      function isNumeric(val) {
        return !isNaN(val) && !isNaN(parseFloat(val));
      }

      if (val === null) {
        return true
      }

      if (val.length > length) {
        this.$emit(
          "bad-input",
          "Inputted value length was too long (24 characters allowed)."
        )
        return false
      }

      if (type == "number") {
        if (isNumeric(val)) {
          return true
        } else {
          this.$emit(
            "bad-input",
            "Look out! A numerical value is expected here."
          )
          return false
        }
      } else if (type == "string") {
        return true
      }
    },
    filter(event) {
      event = event ? event : window.event
      let expect = event.target.value.toString() + event.key.toString()

      let validVal = this.handleValidateValue(expect, "number", 24)
      if (!validVal) event.preventDefault()
    },
  },
}
</script>
<style scoped>
.arva-alert {
  background-color: #f7c0be;
}

.cell-table {
  padding: 2px 6px;
}

.pre-gen {
  background-color: #fedb80;
}

.bg-white {
  color: white;
}

.cell-text {
  font-weight: 600;
  color: white;
}

.machine {
  background-color: #c0dce2;
}

.complete {
  background-color: #c7e3c1;
}

.copy-icon {
  cursor: pointer;
  color: #0f9aee;
}

.delete {
  color: #cc0101;
  cursor: pointer;
}

.input-check {
  cursor: pointer;
}

.select-check {
  margin-top: 14px;
  cursor: pointer;
}

.submit-icon {
  color: #c7e3c1;
}

.medium-column {
  width: 140px;
}

.large-column {
  width: 240px;
}

.marge-column {
  width: 180px;
}

.v-input {
  font-size: 18px;
}
</style>
